export class SaveDepositVoucher {
    public userID: string;
    public orderCode: string;
    public depositVoucherPhotoContent: string;
    public depositVoucherPhotoExtension: string;
    public barcode: string;
}
